import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import clsx from 'clsx';
    

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CBadge',
  props: {
        status: {
            type: String,
            default: "",
        },
        className: {
            type: String,
            default: "",
        }
    },
  setup(__props) {

const props = __props

    

    let statusCss = "text-black bg-white border border-black"

    switch (props.status) {
        case "Active":
            statusCss = "text-green-800 bg-green-200"
            break;
        case "Paid":
            statusCss = "text-green-800 bg-green-200"
            break;
        case "Pending":
            statusCss = "text-yellow-600 bg-yellow-200"
            break;
        case "Past Due":
        case "Payment Failed":
            statusCss = "text-red-800 bg-red-300"
            break;
        case "Cancelled":
            statusCss = "text-gray-700 bg-gray-200"
            break;
        default:
            break;
    }

    const classes = clsx(
        props.className,
        statusCss,
        "rounded-lg p-2 text-sm font-semibold w-max"
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})